import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const PptReplayEmbedContainer = styled.div`
    border: 1px solid ${({ theme }) => theme.Surface.border};
    border-radius: 8px;
    height: 100%;
    width: 100%;
`;

export const PptReplayHeader = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['24bCaps']};
    font-style: italic;
    font-weight: 900;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    height: 64px;
    border-bottom: 1px solid ${({ theme }) => theme.Surface.border};

    svg {
        height: 28px;
        width: 120px;
        margin-right: 8px;
    }

    ${BaseStyle.Mixins.screenSizes.small} {
        ${BaseStyle.Mixins.fontStyles.ui['14b']};
        width: 100px;
        font-weight: 900;
        padding: 12px;

        svg {
            height: 24px;
            width: 94px;
            margin-right: 4px;
        }
    }
`;

export const TeamMatchUp = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16b']};
    text-align: center;
    position: relative;
    top: 12px;
    z-index: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    ${BaseStyle.Mixins.screenSizes.smallerThanMedium} {
        ${BaseStyle.Mixins.fontStyles.ui['12b']};
        top: 4px;
    }

    ${BaseStyle.Mixins.screenSizes.small} {
        ${BaseStyle.Mixins.fontStyles.ui['10b']};
        top: 2px;
    }
`;

export const MatchupDate = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']};
    color: ${({ theme }) => theme.Text.secondary};
    margin-top: 4px;

    ${BaseStyle.Mixins.screenSizes.smallerThanMedium} {
        ${BaseStyle.Mixins.fontStyles.ui['10m']};
        margin-top: 2px;
    }

    ${BaseStyle.Mixins.screenSizes.small} {
        ${BaseStyle.Mixins.fontStyles.ui['8m']};
        margin-top: 1px;
    }
`;
